import { useEffect } from "react";

const SITE = "https://dynamisdecisionintelligence.com";

export const useSEO = ({ title, description, path = "", lang = "it" }) => {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Dynamis Decision Intelligence");
    setMeta("property", "og:url", `${SITE}${path}`);
    setMeta("property", "og:image", `${SITE}/logo.png`);
    setMeta("property", "og:locale", lang === "en" ? "en_GB" : "it_IT");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", `${SITE}/logo.png`);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE}${path}`);
    document.documentElement.lang = lang;
  }, [title, description, path, lang]);
};
